import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  communicateTitle: {
    id: `seo_core_concepts_communicate_title`,
  },
  immerseTitle: {
    id: `seo_core_concepts_immerse_title`,
  },
  learnTitle: {
    id: `seo_core_concepts_learn_title`,
  },
  communicateDescription: {
    id: `seo_core_concepts_communicate_description`,
  },
  communicateMarketingDescription: {
    id: 'seo_marketing_message_card_description_situations',
  },
  immerseMarketingDescription: {
    id: `seo_core_concepts_immerse_description`,
  },
  learnMarketingDescription: {
    id: `seo_core_concepts_learn_description`,
  },
});

export const en = defineMessages({
  marketingSectionTitle: {
    id: 'seo_blue_beetle_marketing_title_en',
  },
  ctaButton: {
    id: 'seo_marketing_message_horizontal_button_label_en',
  },
});

export const en_us = defineMessages({
  marketingSectionTitle: {
    id: 'seo_blue_beetle_marketing_title_en_us',
  },
  ctaButton: {
    // Use `en` key for shared messages as `en_us` doesn't exist for them
    id: 'seo_marketing_message_horizontal_button_label_en',
  },
});

export const es = defineMessages({
  marketingSectionTitle: {
    id: 'seo_blue_beetle_marketing_title_es',
  },
  ctaButton: {
    id: 'seo_marketing_message_horizontal_button_label_es',
  },
});

export const es_mx = defineMessages({
  marketingSectionTitle: {
    id: 'seo_blue_beetle_marketing_title_es_mx',
  },
  ctaButton: {
    // Use `es` key for shared messages to avoid Mexico suffix
    id: 'seo_marketing_message_horizontal_button_label_es',
  },
});
